var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20844 1.6665C9.17692 1.82851 9.16121 1.99318 9.16154 2.15821C9.16154 3.63887 10.3636 4.83919 11.8464 4.83919C12.0097 4.83838 12.1726 4.82271 12.333 4.79236V10.1075C12.333 12.3436 11.014 13.6665 8.77463 13.6665H3.89725C1.65201 13.6665 0.333008 12.3436 0.333008 10.1075V5.23724C0.333008 3.00114 1.65201 1.6665 3.89725 1.6665H9.20844ZM9.21078 5.66756C9.08042 5.68632 8.96324 5.75704 8.88601 5.86358L7.27976 7.92992L5.45074 6.48992C5.34632 6.40857 5.21348 6.37265 5.08221 6.39027C4.95095 6.40789 4.83233 6.47757 4.75313 6.58358L2.78342 9.12406C2.71419 9.21036 2.67691 9.31788 2.6779 9.42846L2.67963 9.50203C2.69873 9.69537 2.83133 9.86242 3.02126 9.92237C3.23493 9.98982 3.46726 9.90471 3.58655 9.71528L5.23384 7.58455L7.06286 9.0187C7.16689 9.10257 7.3006 9.14059 7.43327 9.12403C7.56594 9.10747 7.68617 9.03775 7.76633 8.93089L9.67155 6.47236V6.46065C9.83466 6.24148 9.79304 5.93243 9.57776 5.76406C9.47355 5.68363 9.34115 5.64881 9.21078 5.66756Z",
    fill: "url(#paint0_linear_1_622)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.9997 3.66658C12.9201 3.66658 13.6663 2.92039 13.6663 1.99992C13.6663 1.07944 12.9201 0.333252 11.9997 0.333252C11.0792 0.333252 10.333 1.07944 10.333 1.99992C10.333 2.92039 11.0792 3.66658 11.9997 3.66658Z",
    fill: "url(#paint1_linear_1_622)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_622",
    x1: 6.33301,
    y1: 1.6665,
    x2: 6.33301,
    y2: 13.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_622",
    x1: 11.9997,
    y1: 0.333252,
    x2: 11.9997,
    y2: 3.66659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLineIcon);
export default __webpack_public_path__ + "static/media/chart-line-Icon.0861beba1c72016d6d5d01586df636a6.svg";
export { ForwardRef as ReactComponent };